// extracted by mini-css-extract-plugin
export default {"dialog":"Dialog_dialog__BftPb","title":"Dialog_title__Cg9B-","content":"Dialog_content__tjuTY","actions":"Dialog_actions__OQ2W3"};